"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringBoolean = exports.DEFAULT_LANG_NAME = exports.GRAPHQL_DATA_LIMIT = exports.DEFAULT_CURRENCY = exports.NEARBY_DC_RANGE = exports.DEFAULT_LANG = void 0;
exports.DEFAULT_LANG = 'hi';
exports.NEARBY_DC_RANGE = 300;
exports.DEFAULT_CURRENCY = '₹';
exports.GRAPHQL_DATA_LIMIT = 100;
var DEFAULT_LANG_NAME;
(function (DEFAULT_LANG_NAME) {
    DEFAULT_LANG_NAME["hi"] = "\u0939\u093F\u0928\u094D\u0926\u0940";
    DEFAULT_LANG_NAME["en"] = "English";
    DEFAULT_LANG_NAME["mr"] = "\u092E\u0930\u093E\u0920\u0940";
    DEFAULT_LANG_NAME["bn"] = "\u09AC\u09BE\u0982\u09B2\u09BE";
    DEFAULT_LANG_NAME["or"] = "\u0A93\u0AA1\u0ABF\u0AAF\u0ABE";
    DEFAULT_LANG_NAME["gu"] = "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0";
})(DEFAULT_LANG_NAME || (exports.DEFAULT_LANG_NAME = DEFAULT_LANG_NAME = {}));
var StringBoolean;
(function (StringBoolean) {
    StringBoolean["TRUE"] = "true";
    StringBoolean["FALSE"] = "false";
})(StringBoolean || (exports.StringBoolean = StringBoolean = {}));
